import { apiClient } from '@/services/base'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { GetUser } from '../getReportSearchAsync/interfaces/request'
import { IGetUserByIdRequest } from './interfaces/request'
import { IGetUserByIdResponse } from './interfaces/response'

export const GetUserByIdService = async (
  params: IGetUserByIdRequest,
): Promise<IGetUserByIdResponse> => {
  const response = await apiClient.get('api/user/getById', {
    params,
  })

  return response
}

export const useGetUserByIdService = (
  params: IGetUserByIdRequest,
  variant: GetUser,
): UseQueryResult<IGetUserByIdResponse, Error> => {
  return useQuery<IGetUserByIdResponse>({
    queryKey: [variant, params],
    queryFn: () => GetUserByIdService(params),
    enabled: !!params.id,
  })
}

export type { IGetUserByIdRequest, IGetUserByIdResponse }
